import { useEffect, useState } from 'react';
import { IExternalMenuItem, IVivliConfigurationApi } from '@vivli/shared/infrastructure/interface';
import { first } from 'rxjs/operators';

export function useExternalMenuItemsInit(vivliConfigApi: IVivliConfigurationApi) {
    const [externalMenuItems, setExternalMenuItems] = useState<IExternalMenuItem[]>();

    useEffect(() => {
        const sub = vivliConfigApi.getExternalMenuItems().pipe(first()).subscribe({
            next: setExternalMenuItems,
        });

        return () => {
            sub.unsubscribe();
        };
    }, []);

    return externalMenuItems;
}
